export const initialData = [
  {
    title: "Website",
    key: "/website",
    permissions: { read: false, write: false, edit: false },
    children: [
      {
        title: "CMS",
        key: "/cms",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Homepage",
            key: "/homepage",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "Announcement",
                key: "/announcement",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/homepage/announcement",
              },
              {
                title: "Banner",
                key: "/banner",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/homepage/banner",
              },
              {
                title: "Destinations",
                key: "/destinations",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/homepage/destinations",
              },
              {
                title: "Home",
                key: "/home",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/homepage/home",
              },
              {
                title: "Experience",
                key: "/experience",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/homepage/experience",
              },
              {
                title: "Menubar",
                key: "/menubar",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/homepage/menubar",
              },
            ],
            slug: "/website/cms/homepage",
          },
          {
            title: "Crisis page",
            key: "/crisis-page",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "Crisis Popup",
                key: "/crisis-popup",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/crisis-page/crisis-popup",
              },
              {
                title: "Crisis Data",
                key: "/Crisis-data",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/cms/crisis-page/Crisis-data",
              },
            ],
            slug: "/website/cms/crisis-page",
          },
          {
            title: "Packages",
            key: "/packages",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/cms/packages",
          },
          {
            title: "Promo Index",
            key: "/promo-index",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/cms/promo-index",
          },
          {
            title: "Special Pages",
            key: "/special-pages",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/cms/special-pages",
          },
          {
            title: "Newsletter",
            key: "/news-letter",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/cms/news-letter",
          },
        ],
        slug: "/website/cms",
      },
      {
        title: "Masters",
        key: "/masters",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Markets",
            key: "/markets",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/masters/markets",
          },
          {
            title: "Cabin Master",
            key: "/cabin-master",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/masters/cabin-master",
          },
          {
            title: "Cabin Types",
            key: "/cabin-types",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/masters/cabin-types",
          },
          {
            title: "Cabin Category",
            key: "/cabin-category",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/masters/cabin-category",
          },
          {
            title: "Ancillary",
            key: "/ancillary-details",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/masters/ancillary-details",
          },
        ],
        slug: "/website/masters",
      },
      {
        title: "Bookings",
        key: "/bookings",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Cabin Bookings",
            key: "/cabin-booking",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/bookings/cabin-booking",
          },
          {
            title: "Failed Bookings",
            key: "/leads",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/bookings/leads",
          },
          {
            title: "Error Module",
            key: "/error-module",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/bookings/error-module",
          },
          {
            title: "Best Price",
            key: "/best-price",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/bookings/best-price",
          },
        ],
        slug: "/website/bookings",
      },
      {
        title: "Loyalty",
        key: "/loyalty",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Card Type",
            key: "/card-types",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/loyalty/card-types",
          },
          {
            title: "DRS Instance",
            key: "/drs-instance",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/loyalty/drs-instance",
          },
          {
            title: "Currency",
            key: "/currency",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/loyalty/currency",
          },
          {
            title: "Member Bookings",
            key: "/member-bookings",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/loyalty/member-bookings",
          },
          {
            title: "Loyalty Logs",
            key: "/loyalty-logs",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/loyalty/loyalty-logs",
          },
        ],
        slug: "/website/loyalty",
      },
      {
        title: "Webpages",
        key: "/webpages",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Templates",
            key: "/templates",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/templates",
          },
          {
            title: "Deals",
            key: "/deals",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "Celebration Packages",
                key: "/celebration-packages",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/deals/celebration-packages",
              },
              {
                title: "Onboard Promotions",
                key: "/onboard-promotions",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/deals/onboard-promotions",
              },
              {
                title: "Cash vouchers",
                key: "/cash-vouchers",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/deals/cash-vouchers",
              },
            ],
            slug: "/website/webpages/deals",
          },
          {
            title: "MICE",
            key: "/mice",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/mice",
          },
          {
            title: "Ships",
            key: "/ships",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/ships",
          },
          {
            title: "Destinations",
            key: "/destinations",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/destinations",
          },
          {
            title: "Experiences",
            key: "/experiences",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "The Palace",
                key: "/the-palace",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/experiences/the-palace",
              },
               {
                title: "Little Dreamers",
                key: "/little-dreamers",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/experiences/little-dreamers",
              },
              {
                title: "Entertainment",
                key: "/entertainment",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/experiences/entertainment",
              },
              {
                title: "Life at RWC",
                key: "/life-at-rwc",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/experiences/life-at-rwc",
              },
              {
                title: "Events",
                key: "/events",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/experiences/events",
              },
            ],
            slug: "/website/webpages/experiences",
          },
          {
            title: "About Us",
            key: "/about-us",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "Our Story",
                key: "/our-story",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/about-us/our-story",
              },
              {
                title: "Balcony Class",
                key: "/balcony-class",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/about-us/balcony-class",
              },
              {
                title: "Safety Guides",
                key: "/safety-guides",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/about-us/safety-guides",
              },
              {
                title: "Brochures and Guides",
                key: "/brochures-guides",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/about-us/brochures-guides",
              },
              {
                title: "FAQ",
                key: "/faq",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/about-us/faq",
              },
            ],
            slug: "/website/webpages/about-us",
          },
          {
            title: "Footer",
            key: "/footer",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "Bill of Rights",
                key: "/bill-of-rights",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/bill-of-rights",
              },
              {
                title: "Privacy Policy",
                key: "/privacy-policy",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/privacy-policy",
              },
              {
                title: "Cookie Policy",
                key: "/cookie-policy",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/cookie-policy",
              },
              {
                title: "Terms of Usage",
                key: "/terms-of-usage",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/terms-of-usage",
              },
              {
                title: "Passage Terms",
                key: "/passage-terms",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/passage-terms",
              },
              {
                title: "Terms And Conditions",
                key: "/terms-and-conditions",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/terms-and-conditions",
              },
              {
                title: "Career",
                key: "/career",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/career",
              },
              {
                title: "Media & Resources",
                key: "/press-releases",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/press-releases",
              },
              {
                title: "Contact Us",
                key: "/contact-us",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/footer/contact-us",
              },
            ],
            slug: "/website/webpages/footer",
          },
          {
            title: "Header",
            key: "/header",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "Prepare For Your Cruise",
                key: "/prepare-for-your-cruise",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/header/prepare-for-your-cruise",
              },
              {
                title: "Know Before You Sail",
                key: "/know-before-you-sail",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/header/know-before-you-sail",
              },
              {
                title: "Best price guarantee",
                key: "/best-price-guarantee",
                permissions: { read: false, write: false, edit: false },
                slug: "/website/webpages/header/best-price-guarantee",
              },
            ],
            slug: "/website/webpages/header",
          },
          {
            title: "Blog",
            key: "/blog",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/blog",
          },
          {
            title: "Vlog",
            key: "/vlog",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/vlog",
          },
          {
            title: "Popup",
            key: "/popup",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/popup",
          },
          {
            title: "SEO Meta Tag",
            key: "/seo-meta-tag",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/seo-meta-tag",
          },
          {
            title: "Login Page",
            key: "/login-page",
            permissions: { read: false, write: false, edit: false },
            slug: "/website/webpages/login-page",
          },
        ],
        slug: "/website/webpages",
      },
    ],
    slug: "/website",
  },
  {
    title: "Mobile CMS App",
    key: "/shore",
    permissions: { read: false, write: false, edit: false },
    children: [
      {
        title: "Masters",
        key: "/mobile-masters",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Categories",
            key: "/activity-categories",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/mobile-masters/activity-categories",
            children: [
              {
                title: "Genting Dream",
                key: "/genting-dream",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/activity-categories/genting-dream",
              },
              {
                title: "Star Navigator",
                key: "/star-navigator",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/activity-categories/star-navigator",
              },
              {
                title: "Star Voyager",
                key: "/star-voyager",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/activity-categories/star-voyager",
              },
            ],
          },
          {
            title: "Venues",
            key: "/venue",
            permissions: { read: false, write: false, edit: false },
            children: [
              {
                title: "Genting Dream",
                key: "/genting-dream",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/venue/genting-dream",
              },
              {
                title: "Star Navigator",
                key: "/star-navigator",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/venue/star-navigator",
              },
              {
                title: "Star Voyager",
                key: "/star-voyager",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/venue/star-voyager",
              },
            ],
            slug: "/shore/mobile-masters/venue",
          },
          {
            title: "Itinerary",
            key: "/packages",
            permissions: { read: false, write: false, edit: false },
               children: [
              {
                title: "Genting Dream",
                key: "/genting-dream",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/packages/genting-dream",
              },
              {
                title: "Star Navigator",
                key: "/star-navigator",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/packages/star-navigator",
              },
              {
                title: "Star Voyager",
                key: "/star-voyager",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/packages/star-voyager",
              },
            ],
            slug: "/shore/mobile-masters/packages",
            
          },
          {
            title: "Currency",
            key: "/sailing_currency",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/mobile-masters/sailing_currency",
            children: [
              {
                title: "Genting Dream",
                key: "/genting-dream",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/sailing_currency/genting-dream",
              },
              {
                title: "Star Navigator",
                key: "/star-navigator",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/sailing_currency/star-navigator",
              },
              {
                title: "Star Voyager",
                key: "/star-voyager",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/mobile-masters/sailing_currency/star-voyager",
              },
            ],
          },
          {
            title: "Age Validation",
            key: "/age-validation",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/mobile-masters/age-validation",
          },
        ],
        slug: "/shore/mobile-masters",
      },
      {
        title: "Mobile Ancillary",
        key: "/mobile-ancillary",
        permissions: { read: false, write: false, edit: false },
        slug: "/shore/mobile-ancillary",
        children: [
          {
            title: "Ancillary Purchases",
            key: "/purchases",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/mobile-ancillary/purchases",
          },
          {
            title: "Error Module",
            key: "/error-module",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/mobile-ancillary/error-module",
          },
          {
            title: "Seaware Ancillary CMS",
            key: "/seaware-ancillary",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/mobile-ancillary/seaware-ancillary",
          },
        ],
      },
      {
        title: "Homepage",
        key: "/home-page",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Genting Dream",
            key: "/genting-dream",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/home-page/genting-dream",
          },
          {
            title: "Star Navigator",
            key: "/star-navigator",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/home-page/star-navigator",
          },
          {
            title: "Star Voyager",
            key: "/star-voyager",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/home-page/star-voyager",
          },
        ],
        slug: "/shore/home-page",
      },
      {
        title: "All Pages",
        key: "/all-pages",
        children: [
          {
            title: "Genting Dream",
            key: "/genting-dream",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/all-pages/genting-dream",
          },
          {
            title: "Star Navigator",
            key: "/star-navigator",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/all-pages/star-navigator",
          },
          {
            title: "Star Voyager",
            key: "/star-voyager",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/all-pages/star-voyager",
          },
        ],
        permissions: { read: false, write: false, edit: false },
        slug: "/shore/all-pages",
      },
      // {
      //   title: "Dynamic Pages",
      //   key: "/ship",
      //   permissions: { read: false, write: false, edit: false },
      //   children: [
      //     {
      //       title: "Cruise Page",
      //       key: "/cruise-page",
      //       permissions: { read: false, write: false, edit: false },
      //       children: [
      //         {
      //           title: "Genting Dream",
      //           key: "/genting-dream",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/cruise-page/genting-dream",
      //         },
      //         {
      //           title: "Star Navigator",
      //           key: "/star-navigator",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/cruise-page/star-navigator",
      //         },
      //         {
      //           title: "Star Voyager",
      //           key: "/star-voyager",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/cruise-page/star-voyager",
      //         },
      //       ],
      //       slug: "/shore/ship/cruise-page",
      //     },
      //     {
      //       title: "Daily Planner",
      //       key: "/daily-planner",
      //       permissions: { read: false, write: false, edit: false },
      //       children: [
      //         {
      //           title: "Genting Dream",
      //           key: "/genting-dream",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/daily-planner/genting-dream",
      //         },
      //         {
      //           title: "Star Navigator",
      //           key: "/star-navigator",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/daily-planner/star-navigator",
      //         },
      //         {
      //           title: "Star Voyager",
      //           key: "/star-voyager",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/daily-planner/star-voyager",
      //         },
      //       ],
      //       slug: "/ship/daily-planner",
      //     },
      //     {
      //       title: "Shortcuts",
      //       key: "/ship-shortcuts",
      //       permissions: { read: false, write: false, edit: false },
      //       children: [
      //         {
      //           title: "Genting Dream",
      //           key: "/genting-dream",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/ship-shortcuts/genting-dream",
      //         },
      //         {
      //           title: "Star Navigator",
      //           key: "/star-navigator",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/ship-shortcuts/star-navigator",
      //         },
      //         {
      //           title: "Star Voyager",
      //           key: "/star-voyager",
      //           permissions: { read: false, write: false, edit: false },
      //           slug: "/shore/ship/ship-shortcuts/star-voyager",
      //         },
      //       ],
      //       slug: "/ship/ship-shortcuts",
      //     },
      //   ],
      //   slug: "/ship",
      // },
      {
        title: "Cruise Page",
        key: "/cruise-page",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Genting Dream",
            key: "/genting-dream",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/cruise-page/genting-dream",
          },
          {
            title: "Star Navigator",
            key: "/star-navigator",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/cruise-page/star-navigator",
          },
          {
            title: "Star Voyager",
            key: "/star-voyager",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/cruise-page/star-voyager",
          },
        ],
        slug: "/shore/ship/cruise-page",
      },
      {
        title: "Daily Planner",
        key: "/daily-planner",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Genting Dream",
            key: "/genting-dream",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/daily-planner/genting-dream",
          },
          {
            title: "Star Navigator",
            key: "/star-navigator",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/daily-planner/star-navigator",
          },
          {
            title: "Star Voyager",
            key: "/star-voyager",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/daily-planner/star-voyager",
          },
        ],
        slug: "/ship/daily-planner",
      },
      {
        title: "Shortcuts",
        key: "/ship-shortcuts",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Genting Dream",
            key: "/genting-dream",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/ship-shortcuts/genting-dream",
          },
          {
            title: "Star Navigator",
            key: "/star-navigator",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/ship-shortcuts/star-navigator",
          },
          {
            title: "Star Voyager",
            key: "/star-voyager",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/ship-shortcuts/star-voyager",
          },
        ],
        slug: "/ship-shortcuts",
      },
      {
        title: "Notifications",
        key: "/notifications",
        permissions: { read: false, write: false, edit: false },
        slug: "/shore/notifications",
      },
      {
        title: "Webpages",
        key: "/webpages",
        permissions: { read: false, write: false, edit: false },
        children: [
          {
            title: "Legal",
            key: "/legal",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/webpages/legal",
            children: [
              {
                title: "Bill of Rights",
                key: "/mobile-bill-of-rights",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/webpages/legal/mobile-bill-of-rights",
              },
              {
                title: "Privacy Policy",
                key: "/mobile-privacy-policy",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/webpages/legal/mobile-privacy-policy",
              },
              {
                title: "Cookie Policy",
                key: "/mobile-cookie-policy",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/webpages/legal/mobile-cookie-policy",
              },
              {
                title: "Terms of Usage",
                key: "/mobile-terms-of-usage",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/webpages/legal/mobile-terms-of-usage",
              },
              {
                title: "Passage Terms",
                key: "/mobile-passage-terms",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/webpages/legal/mobile-passage-terms",
              },
              {
                title: "Terms And Conditions",
                key: "/mobile-terms-and-conditions",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/webpages/legal/mobile-terms-and-conditions",
              },
              {
                title: "Safety Information",
                key: "/mobile-safety-and-guides",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/webpages/legal/mobile-safety-and-guides",
              },
            ],
          },
        ],
      },
      {
        title: "Back Office",
        key: "/back-office",
        permissions: { read: false, write: false, edit: false },
        slug: "/shore/back-office",
        children: [
          {
            title: "Shore Excursions",
            key: "/shore-excursions",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/back-office/shore-excursions",
            children: [
              {
                title: "Management",
                key: "/management",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/back-office/shore-excursions/management",
                children: [
                  {
                    title: "Genting Dream",
                    key: "/genting-dream",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/shore-excursions/management/genting-dream",
                  },
                  {
                    title: "Star Navigator",
                    key: "/star-navigator",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/shore-excursions/management/star-navigator",
                  },
                  {
                    title: "Star Voyager",
                    key: "/star-voyager",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/shore-excursions/management/star-voyager",
                  },
                ],
              },
              {
                title: "Report",
                key: "/report",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/back-office/shore-excursions/report",
                children: [
                  {
                    title: "Sales Reports",
                    key: "/sales",
                    permissions: { read: false, write: false, edit: false, download: false },
                    slug: "/shore/back-office/shore-excursions/report/sales",
                  },
                  {
                    title: "Summary Report",
                    key: "/summary",
                    permissions: { read: false, write: false, edit: false, download: false },
                    slug: "/shore/back-office/shore-excursions/report/summary",
                  },
                ],
              },
              {
                title: "Void Transaction",
                key: "/void-transaction",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/back-office/shore-excursions/void-transaction",
              },
            ],
          },
          {
            title: "Onboard Purchase",
            key: "/entertainment",
            permissions: { read: false, write: false, edit: false },
            slug: "/shore/back-office/entertainment",
            children: [
              {
                title: "Management",
                key: "/management",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/back-office/entertainment/management",
                children: [
                  {
                    title: "Genting Dream",
                    key: "/genting-dream",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/management/genting-dream",
                  },
                  {
                    title: "Star Navigator",
                    key: "/star-navigator",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/management/star-navigator",
                  },
                  {
                    title: "Star Voyager",
                    key: "/star-voyager",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/management/star-voyager",
                  },
                ],
              },
              {
                title: "Revenue Center",
                key: "/revenue-center",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/back-office/entertainment/revenue-center",
                children: [
                  {
                    title: "Genting Dream",
                    key: "/genting-dream",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/revenue-center/genting-dream",
                  },
                  {
                    title: "Star Navigator",
                    key: "/star-navigator",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/revenue-center/star-navigator",
                  },
                  {
                    title: "Star Voyager",
                    key: "/star-voyager",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/revenue-center/star-voyager",
                  },
                  {
                    title: "Itemizer",
                    key: "/itemizer",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/revenue-center/itemizer",
                  },
                  {
                    title: "Menu Item",
                    key: "/menu-item",
                    permissions: { read: false, write: false, edit: false },
                    slug: "/shore/back-office/entertainment/revenue-center/menu-item",
                  },
                ],
              },
              {
                title: "Report",
                key: "/report",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/back-office/entertainment/report",
                children: [
                  {
                    title: "Sales Reports",
                    key: "/sales",
                    permissions: { read: false, write: false, edit: false, download: false },
                    slug: "/shore/back-office/entertainment/report/sales",
                  },
                  {
                    title: "Summary Report",
                    key: "/summary",
                    permissions: { read: false, write: false, edit: false, download: false },
                    slug: "/shore/back-office/entertainment/report/summary",
                  },
                ],
              },
              {
                title: "Void Transaction",
                key: "/void-transaction",
                permissions: { read: false, write: false, edit: false },
                slug: "/shore/back-office/entertainment/void-transaction",
              },
            ],
          },
        ],
      },
    ],
    slug: "/shore/webpages",
  },
  {
    title: "Profile",
    key: "/profile",
    permissions: { read: false, write: false, edit: false },
    children: [
      {
        title: "My Profile",
        key: "/my-profile",
        permissions: { read: false, write: false, edit: false },
        slug: "/profile/my-profile",
      },
      {
        title: "Roles",
        key: "/role",
        permissions: { read: false, write: false, edit: false },
        slug: "/profile/role",
      },
      {
        title: "User Management",
        key: "/user-management",
        permissions: { read: false, write: false, edit: false },
        slug: "/profile/user-management",
      },
      {
        title: "Reset Password",
        key: "/reset-password",
        permissions: { read: false, write: false, edit: false },
        slug: "/profile/reset-password",
      },
    ],
    slug: "/profile",
  },
  {
    title: "Logs",
    key: "/logs",
    permissions: { read: false, write: false, edit: false },
    children: [
      {
        title: "Log API",
        key: "/log-api",
        permissions: { read: false, write: false, edit: false },
        slug: "/logs/log-api",
      },
      {
        title: "User Logs",
        key: "/user-logs",
        permissions: { read: false, write: false, edit: false },
        slug: "/logs/user-logs",
      },
    ],
    slug: "/logs",
  },
  {
    title: "Logout",
    key: "Logout",
    permissions: { read: false, write: false, edit: false },
    slug: "Logout",
  },
];
